import { render, staticRenderFns } from "./payors.vue?vue&type=template&id=26a997ca&"
import script from "./payors.vue?vue&type=script&lang=js&"
export * from "./payors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports